var exports = {
  "az": "Box__9wHRvY",
  "EY": "Text__0nsZGM",
  "UE": "Text_1__FwUDMr",
};

module.exports = exports;
